import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { BrokerageZeroComponent } from './brokerage-zero.component';
import { SvgIconModule } from '../../../components/svg-icon/svg-icon.module';
import { TrCheckboxModule } from '../../../components/tr-forms-inputs/tr-checkbox/tr-checkbox.module';

@NgModule({
    imports: [FormsModule, ReactiveFormsModule, CommonModule, SvgIconModule, TrCheckboxModule],
    declarations: [BrokerageZeroComponent],
    entryComponents: [BrokerageZeroComponent],
})

export class BrokerageZeroModule {}
